import { ClickAwayListener, FormControl, MenuProps } from '@mui/material';
import { colors } from 'crono-fe-common/theme';
import { useState } from 'react';
import { CronoMenuItem, CronoSelect } from 'crono-fe-common/components/Select';
import { TemplateSearchSort } from 'crono-fe-common/types/DTO/templateSearch';
import {
  getTemplateSortOptions,
  getTemplateSortValues,
} from 'crono-fe-common/utils';
import React from 'react';
import TemplateType from 'crono-fe-common/types/enums/templateType';

export const TEMPLATE_SORT_OPTIONS: TemplateSearchSort[] =
  getTemplateSortValues(TemplateType.EMAIL);

export interface ITemplatesSortPicker {
  sortOption: TemplateSearchSort;
  setSortOption: (sort: TemplateSearchSort) => void;
  borderColor?: string;
  fontSize?: number;
  maxWidth?: number;
  MenuProps?: Partial<MenuProps>;
  noBorder?: boolean;
  noPadding?: boolean;
  templateType: TemplateType;
}

const TemplatesSortPicker = ({
  sortOption,
  setSortOption,
  borderColor,
  fontSize,
  maxWidth,
  MenuProps,
  noBorder = false,
  noPadding = false,
  templateType,
}: ITemplatesSortPicker) => {
  const [isOpen, setIsOpen] = useState(false);
  const sortOptions = getTemplateSortOptions(templateType);

  const sortSelectSx = {
    fontSize: fontSize ? `${fontSize}px` : '12px',
    boxShadow: 'none',
    backgroundColor: colors.white,
    color: colors.primary,
    ...(noPadding
      ? {
          padding: '0px 28px 0 10px !important',
          '& .MuiSelect-select': {
            padding: '0px !important',
            paddingTop: '0px !important',
            paddingBottom: '0px !important',
          },
          '& .MuiInputBase-input': {
            padding: '0px !important',
          },
        }
      : {
          padding: '2px',
        }),
    ...(noBorder
      ? {
          border: 'none !important',
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none !important',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none !important',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none !important',
          },
        }
      : {
          '.MuiOutlinedInput-notchedOutline': {
            border: `1px solid ${borderColor ?? colors.grey3}`,
            borderRadius: 2,
          },
        }),
  };

  return (
    <ClickAwayListener onClickAway={() => setIsOpen(false)}>
      <FormControl
        sx={{ maxWidth: maxWidth ? `${maxWidth}px` : 'none', mt: 1, mb: 1 }}
        size="small"
      >
        <CronoSelect
          value={sortOption}
          open={isOpen}
          onClick={() => setIsOpen((prev) => !prev)}
          onChange={(ev) => {
            setSortOption(ev.target.value as TemplateSearchSort);
          }}
          sx={sortSelectSx}
          MenuProps={MenuProps}
        >
          {sortOptions.map(({ value, label }) => (
            <CronoMenuItem key={value} value={value}>
              {label}
            </CronoMenuItem>
          ))}
        </CronoSelect>
      </FormControl>
    </ClickAwayListener>
  );
};

export default TemplatesSortPicker;
